const classes = {
  hide: 'hide',
};

const selectors = {
  vehiclesContainer: '.vehicle-comparison-preview-panel__vehicles-container',
  vehiclesList: '.vehicle-comparison-preview-panel__vehicles',
  vehicle: '.vehicle-comparison-preview-panel__vehicles-vehicle',
  container: '[data-comp-vehicle-comparison-preview-panel]',
  header: '.vehicle-comparison-preview-panel__title--minimized',
  minimizeBtn: '[data-panel-control-action="minimize"]',
  maximizeBtn: '[data-panel-control-action="maximize"]',
  navigationBtn: '[data-panel-control-action="navigate"]',
  clearAllBtn: '[data-panel-control-action="clear"]',
  mobileNavigateBtn: '.vehicle-comparison-preview-panel__mobile-navigate',
  mobileNavigateBtnText: '.btn__text',
};

export { classes, selectors };
